export const List = () => import("./List.vue");
export const View = () => import("./View.vue");
export const Create = () => import("./Create.vue");
export const Edit = () => import("./Edit.vue");
export const PDFView = () => import("./PDFView.vue");
export const CRCreate = () => import("./CR_Create.vue");
export const CROutCreate = () => import("./CR_Outgoing.vue");
